export const DEFAULT_CONTENT = {
  error: {
    title: 'Hata Oluştu',
    description: 'İşleminizi şuanda gerçekleştiremiyoruz',
  },
  success: {
    title: 'İşlem Başarılı',
    description: 'İşleminiz başarıyla gerçekleştirildi.',
  },
  info: {
    title: 'Ürün Tükendi!',
    description: 'Sepetinizdeki bazı ürünler tükendi.',
  },
};
